import { Core } from "../shared/core/ovs.core";

export class DisplayOptionsService {

    public getLabel(labelName: string): string {
       const label = Core.current.currentConfiguration.Labels.firstOrDefault(l => l.Name === labelName);
       if(label) return label.DisplayText;
       return '';
    }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/services/display-options.service.ts